import React from 'react';
import { Table } from './elements'
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { Span, Margin, P } from '@helpers';

export const FontSize = ({t}) => {
    return (
      <PageWrapper>
        <Container paddingTop='117px' marginLeft='102px' marginRight='42px' paddingBottom='101px'>
          <P weight='400' size='25px' height='30px'>{t("Font size")}</P>
          <FlexDiv>
            <Text width='308px' marginTop='5px' paddingBefforeText="45px" paddingAffterText='30px'>
              <p>
                {t("The font size used on the company website and in the marketing content is adjusted to ensure that the client is as comfortable as possible to perceive the information. The optimal sizes and fonts for the highlighted text are presented here.")} 
              </p>
            </Text>
            <Margin marginLeft='71px' marginTop='30px'>
              <Table width='348px'>
                <thead>
                  <tr>
                    <td></td>
                    <td><Span size='15px' height='18.29px' color='#BDBDBD'>{t("Weight")}</Span></td>
                    <td><Span size='15px' height='18.29px' color='#BDBDBD'>{t("Size")}</Span></td>
                  </tr>
                </thead>
                <tbody>
                <tr>
                  <td><Span size='17px' weight='700' height='20.72px'>{t("Headline")} H1</Span></td>
                  <td>Bold</td>
                  <td>70px</td>
                </tr>
                <tr>
                  <td><Span size='17px' weight='600' height='20.72px'>{t("Headline")} H2</Span></td>
                  <td>SemiBold</td>
                  <td>35px</td>
                </tr>
                <tr>
                  <td><Span size='17px' weight='400' height='20.72px'>{t("Headline")} H3</Span></td>
                  <td>Regular</td>
                  <td>20px</td>
                </tr>
                <tr>
                  <td><Span size='17px' weight='500' height='20.72px'>{t("Headline")} H4</Span></td>
                  <td>Medium</td>
                  <td>18px</td>
                </tr>
                <tr>
                  <td><Span size='17px' weight='400' height='20.72px'>{t("Headline")} H5</Span></td>
                  <td>Regular</td>
                  <td>15px</td>
                </tr>
                </tbody>
              </Table>
            </Margin>
          </FlexDiv>
        </Container>
      </PageWrapper>
  );
};
